import { HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";

enum TooltipSubType {
  error = "error"
}

export type InPlaceTooltipProps = HtmlHTMLAttributes<HTMLDivElement> & {
  type?: "error",
  children?: ReactNode,
  className?: string,
};

export const InPlaceTooltip = memo<InPlaceTooltipProps>((
  {
    type,
    children,
    className,
    ...props
  }) => {
  return (
    <div className={styles.container}>
      <div
        className={classNames(className, type && styles[type], styles.root, {
          [styles.error]: type === TooltipSubType.error,
        })}
        {...props}
      >
        {children}
      </div>
    </div>
  );
});

export default InPlaceTooltip;
